<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <!-- Button back -->
                                <div class="d-flex">
                                    <h3>{{$t('fields')}}</h3>
                                    <TableSettings
                                        :allFields="
                                            tables.fields.allFields
                                        "
                                        :activeFields.sync="
                                            tables.fields.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.fields.items"
                                    :fields="
                                        traslateLabels(
                                            tables.fields.fields
                                        )
                                    "
                                    :columnFilterValue.sync="
                                        tables.fields.columnFilterValue
                                    "
                                    items-per-page-select
                                    :itemsPerPageSelect="{
                                        values: [5, 10, 20, 50],
                                    }"
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.fields.rows"
                                    v-bind="tables.fields"
                                >
                                    <template #details="{item}">
                                        <CCollapse :show="Boolean(item._toggled)">
                                            <CCardBody>
                                                <h4>
                                                    {{$t(item.name)}}
                                                </h4>
                                                <p class="text-muted">{{$t('type')}}: {{$t(item.type)}}</p>
                                                <!-- <p class="text-muted" v-if="item.subTagId">{{$t('sub_tag')}}: {{ getSubTagById(item.subTagId) ? getSubTagById(item.subTagId).name: ''  }}</p> -->
                                                <p class="text-muted">{{$t(item.name+'_description')}}</p>
                                                <p class="text-muted" v-if="item.options">{{$t('options')}}: {{item.options}}</p>
                                            </CCardBody>
                                        </CCollapse>
                                    </template>
                                     <template #options="{item, index}">
                                        <td class="py-2">
                                        <CButton
                                            color="primary"
                                            variant="outline"
                                            square
                                            size="sm"
                                            @click="toggleDetails('fields', index)"
                                        >
                                            {{Boolean(item._toggled) ? 'Hide' : 'Show'}}
                                        </CButton>
                                        </td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <button
                                                class="m-2 p-0 btn-export-table"
                                                @click="
                                                    downloadExportTable({
                                                        tableName:
                                                            'fields',
                                                    })
                                                "
                                            >
                                                <span class="block-icon">
                                                    <CIcon
                                                        :content="
                                                            $options.icons
                                                                .cilDataTransferDown
                                                        "
                                                    />
                                                </span>
                                                <span class="text">
                                                    {{ $t("export_to_csv") }}
                                                </span>
                                            </button>
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.fields.total_pages > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.fields.page"
                                        :pages="tables.fields.total_pages"
                                        align="center"
                                    />
                                    <CElementCover :opacity="0.8" class="bg-trasparent" v-if="tables.fields.loading"/>
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ButtonBack from "£lement/ButtonBack";
import TableSettings from "£lement/TableSettings";
import FilterFields from "~/components/FilterFields";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilArrowThickFromRight,
} from "@coreui/icons";

/** Settings */
import FieldsTable from "./Config/Tables/Fields.js";
export default {
    name: "HeadersPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        TableSettings,
        ButtonBack,
        FilterFields,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
    },
    data() {
        return {
            tables: {
                fields: FieldsTable,
            },
        };
    },
    methods: {
        itemPerPage(newValue) {
            this.tables.fields.rows = newValue;
            this.updatePagination(this.tables.fields.page);
        },
        updatePagination(newValue) {
            this.tables.fields.page = newValue;
            this.updateData();
        },
        async updateData(){
            await this.updateTable({
                tableName:"fields", 
                url:'/fields',
                fetch:{
                    baseURL: process.env.VUE_APP_API_CORE,
                },
                adapterFilters: (filters)=>{
                    delete filters.where.created_at
                    return filters;
                }
            });
            this.tables.fields.loading = false;
            this.updatePageLoading(false);
        },
    },
    async mounted(){
        await this.updateData();
    },
    async created(){
        await this.loadSubTags();
    }
};
</script>

<style>
.button-filter {
    display: block;
    margin-right: 0;
    margin-left: auto;
}
</style>